import React from "react"
import { useTrail, animated as a } from 'react-spring'

const TrailInner = ({ isVisible, children, ...props}) => {
  const items = React.Children.toArray(children)
  const trail = useTrail(items.length, {
    config: { mass: 5, tension: 2000, friction: 400 },
    opacity: isVisible ? 1 : 0,
    y: isVisible ? 0 : -40,
    from: { opacity: 0, y: -40 },
  })
  return (
    <div {...props}>
      {trail.map(({ y, ...rest }, index) => (
        <a.div
          key={index}
          // className="trails-text"
          style={{ ...rest, transform: y.interpolate((y) => `translateY(${y}px)`) }}>
          {items[index]}
        </a.div>
      ))}
    </div>
  )
}

export default TrailInner